import { Container } from 'inversify-props';
import setupInviteFriend from './invite-friend/setup';
import setupCustomerOverview from './customer-overview/setup';

export default function setupHomeDashboardModule(container: Container) {
  setupInviteFriend(container);
  setupCustomerOverview(container);
}
